import {Component, OnInit, Inject, ViewEncapsulation} from '@angular/core'
import {Router, NavigationEnd, NavigationStart} from "@angular/router";
import {MenuComponent} from "./shared/menu/menu.component";
import {Aot2JitSharingService} from "./shared/services/aot2jitsharing.service";

declare var ga: any;

@Component({
	selector: 'app',
	templateUrl: './app.component.html',
  styleUrls: [ './app.component.scss' ],
  encapsulation: ViewEncapsulation.None
})

export class AppComponent implements OnInit {

  private _routeScrollPositions: {[url: string] : number}[] = [];

  constructor(private router: Router,
              protected aot2JitSharingService: Aot2JitSharingService,
              @Inject('isBrowser') protected isBrowser: boolean) { }

  ngOnInit() {
    if(this.isBrowser) {

      this.aot2JitSharingService.addProvider(this.router);
      this.aot2JitSharingService.addProvider('isBrowser', this.isBrowser);

      this.router.events.subscribe((evt) => {
        //reset the menu flags
        MenuComponent.isMenuOpened = false;
        MenuComponent.isOpeningOrClosingMenu = false;
      });

      this.router.events.pairwise().subscribe(([prevRouteEvent, currRouteEvent]) => {
        if (prevRouteEvent instanceof NavigationEnd && currRouteEvent instanceof NavigationStart) {
          this._routeScrollPositions[prevRouteEvent.url] = window.pageYOffset;
          ga('send', 'pageview', currRouteEvent.url);
        }
        else if (currRouteEvent instanceof NavigationEnd) {
          window.scrollTo(0, this._routeScrollPositions[currRouteEvent.url] || 0);
        }
      })

    }

  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts